import './apiRuntime';
import './analyticsRuntime';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import './i18n';
import './index.css';
import '@fontsource/roboto';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CssVarsProvider, extendTheme } from '@mui/joy/styles';
import AppRoutes from './_routes/AppRoutes';
import { Provider } from 'react-redux';
import store from './_services/Redux/store';
import { cognitoAuthConfig } from './authConfig';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const onSigninCallback = (): void => {
  window.location.href = '/';
};

const joyTheme = extendTheme({
  fontFamily: {
    body: `'Roboto', sans-serif`,
    display: `'Roboto', sans-serif`,
    code: 'monospace',
  },
  // Only 300/400/500/700 Roboto faces are loaded; Joy's default lg is 600.
  fontWeight: { sm: 300, md: 500, lg: 700, xl: 700 },
});

root.render(
  <AuthProvider {...cognitoAuthConfig} onSigninCallback={onSigninCallback}>
    <StrictMode>
      <Provider store={store}>
        <CssVarsProvider theme={joyTheme}>
          <AppRoutes />
        </CssVarsProvider>
      </Provider>
    </StrictMode>
  </AuthProvider>
);
